import { assertNever } from "domains/commons/assertNever";
import { ExploreTabId } from "domains/explore/constants";
import { GetAssetsByAssetIdApiResponse } from "infra/api/generated/api";

export function mapAssetTypeToExploreTab(
  assetType: GetAssetsByAssetIdApiResponse["asset"]["metadata"]["type"]
): ExploreTabId {
  switch (assetType) {
    case "background-removal":
    case "canvas-export":
    case "detection":
    case "inference-controlnet":
    case "inference-controlnet-img2img":
    case "inference-controlnet-inpaint":
    case "inference-controlnet-inpaint-ip-adapter":
    case "inference-controlnet-ip-adapter":
    case "inference-controlnet-reference":
    case "inference-controlnet-texture":
    case "inference-txt2img":
    case "inference-txt2img-ip-adapter":
    case "inference-txt2img-texture":
    case "inference-img2img":
    case "inference-img2img-ip-adapter":
    case "inference-img2img-texture":
    case "inference-inpaint":
    case "inference-inpaint-ip-adapter":
    case "inference-reference":
    case "inference-reference-texture":
    case "pixelization":
    case "reframe":
    case "restyle":
    case "image-prompt-editing":
    case "uploaded":
    case "uploaded-avatar":
    case "upscale":
    case "vectorization":
    case "patch":
    case "generative-fill":
    case "canvas-drawing":
    case "segment":
    case "segmentation-image":
    case "segmentation-mask":
    case "img2img":
    case "txt2img":
    case "txt2audio": ///// not yet
    case "uploaded-audio": ///// not yet
    case "unknown":
      return "image";
    case "skybox-base-360":
    case "upscale-skybox":
      return "skybox";
    case "texture":
    case "texture-albedo":
    case "texture-ao":
    case "texture-edge":
    case "texture-height":
    case "texture-metallic":
    case "texture-normal":
    case "texture-smoothness":
    case "upscale-texture":
      return "texture";
    case "img23d":
    case "txt23d":
    case "uploaded-3d":
      return "3d";
    case "img2video":
    case "txt2video":
    case "video2video":
    case "uploaded-video":
      return "video";
    case "canvas":
      return "canvas";
    default:
      assertNever(assetType);
  }
}
